module.exports = __webpack_public_path__ + "img/bg4.e336919f.png";